import { useTranslation } from "react-i18next";
import { colors } from "../../../data/colors";
import { stdObject } from "../../../data/types/stdObject";
import BasicButton from "../../BasicButton";
import MiniatureFile from "./MiniatureFile";
import RefreshIcon from "@mui/icons-material/Refresh";

export default function FilesManager({
  filesButtons,
  switchFileGroup,
  filesList,
  mainColor,
  handleButtonClick,
  handleFile,
  refreshFiles,
}: stdObject) {
  const { t } = useTranslation();
  return (
    <>
      <div
        className="wrapBox"
        style={{
          backgroundColor: colors.lightGrey2,
          overflow: "auto",
          //  ...style,
        }}
      >
        <table align="center">
          <tbody>
            <tr>
              {filesButtons.map((e: stdObject, index: number) => (
                <td key={index}>
                  <BasicButton
                    onClick={() => switchFileGroup(e.key)}
                    title={t(e.label)}
                    color={
                      filesList.selected === e.key ? mainColor : colors.darkGrey
                    }
                  />
                </td>
              ))}
              <td>
                <BasicButton
                  Icon={RefreshIcon}
                  onClick={refreshFiles}
                  title={t("p.refresh")}
                  color={colors.orange}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="docInfoContent">
        <div className="wrapBox">
          <MiniatureFile
            name={t("p.addFile")}
            add={true}
            onClick={handleButtonClick}
          />
          {filesList[filesList.selected].map((e: string) => (
            <MiniatureFile name={e} add={false} onClick={() => handleFile(e)} />
          ))}
        </div>
      </div>
      <div
        style={{
          backgroundColor: colors.lightGrey,
          padding: 10,
          borderTop: `solid 1px ${colors.darkGrey}`,
          display: "flex",
          flexDirection: "row",
        }}
      >
        {t("p.quantity")}: {filesList[filesList.selected].length}
      </div>
    </>
  );
}
